module.exports = __webpack_public_path__ + "img/wolverhampton-wanderers.41ab6da2.png";